// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shimmer {
  0% {
    background-position: -100px 0;
  }
  100% {
    background-position: 200px 0;
  }
}
@keyframes pulse-dot {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.whats-new-card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.whats-new-card .whats-new-list {
  flex: 1 1;
  overflow-y: auto;
}
.whats-new-card .whats-new-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  cursor: pointer;
}
.whats-new-card .whats-new-item:last-child {
  border-bottom: none;
}
.whats-new-card .whats-new-item:hover {
  background: #fafbfc;
}
.whats-new-card .whats-new-item .item-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.whats-new-card .whats-new-item:hover .item-icon-wrap {
  transform: scale(1.1);
}
.whats-new-card .whats-new-item.blog-item .item-icon-wrap {
  background: rgba(68, 3, 191, 0.1);
  color: #4403bf;
}
.whats-new-card .whats-new-item.offer-item .item-icon-wrap {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(245, 158, 11, 0.05));
  color: #f59e0b;
  box-shadow: 0 0 0 1px rgba(245, 158, 11, 0.15);
}
.whats-new-card .whats-new-item.offer-item:hover .item-icon-wrap {
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);
}
.whats-new-card .whats-new-item.news-item .item-icon-wrap {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(99, 102, 241, 0.05));
  color: #3b82f6;
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.15);
}
.whats-new-card .whats-new-item.news-item:hover .item-icon-wrap {
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
}
.whats-new-card .whats-new-item .item-content {
  flex: 1 1;
  min-width: 0;
}
.whats-new-card .whats-new-item .item-title {
  font-size: 13px;
  font-weight: 500;
  color: #1d2026;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.whats-new-card .whats-new-item .item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
}
.whats-new-card .whats-new-item .item-type-label {
  font-size: 11px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.whats-new-card .whats-new-item .item-type-label.blog-label {
  background: rgba(68, 3, 191, 0.08);
  color: #4403bf;
}
.whats-new-card .whats-new-item .item-type-label.offer-label {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(251, 191, 36, 0.1));
  color: #b45309;
  border: 1px solid rgba(245, 158, 11, 0.15);
}
.whats-new-card .whats-new-item .item-type-label.news-label {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(99, 102, 241, 0.08));
  color: #1d4ed8;
  border: 1px solid rgba(59, 130, 246, 0.15);
}
.whats-new-card .whats-new-item .item-date {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: #9ca3af;
}
.whats-new-card .whats-new-item .item-validity {
  font-size: 11px;
  color: #b45309;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 2px;
}
.whats-new-card .whats-new-item .item-validity::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #f59e0b;
  animation: pulse-dot 1.5s ease-in-out infinite;
}
.whats-new-card .whats-new-item .item-arrow {
  background: none;
  border: none;
  padding: 0;
  color: #c0c0c0;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.15s ease;
}
.whats-new-card .whats-new-item:hover .item-arrow {
  color: #4403bf;
}
.whats-new-card .offer-item-wrap {
  border-bottom: 1px solid #f0f0f0;
  border-left: 3px solid transparent;
  transition: border-color 0.2s ease;
}
.whats-new-card .offer-item-wrap:last-child {
  border-bottom: none;
}
.whats-new-card .offer-item-wrap:hover {
  border-left-color: #f59e0b;
}
.whats-new-card .offer-item-wrap.news-item-wrap:hover {
  border-left-color: #3b82f6;
}
.whats-new-card .offer-item-wrap .whats-new-item {
  border-bottom: none;
}
.whats-new-card .offer-expanded {
  margin: 0 20px 12px;
  padding: 10px 14px;
  border-radius: 6px;
  background: #fafbfc;
  border-left: 3px solid #000;
  font-size: 13px;
  color: #1d2026;
  line-height: 1.6;
}
.whats-new-card .offer-expanded p {
  margin: 0;
}
.whats-new-card .offer-expanded .offer-expanded-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
  opacity: 0.5;
}
.whats-new-card .view-all-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #4403bf;
  cursor: pointer;
  border-top: 1px solid #f0f0f0;
  transition: background 0.15s ease;
}
.whats-new-card .view-all-link:hover {
  background: rgba(68, 3, 191, 0.04);
}

@media (max-width: 1024px) {
  .whats-new-card .whats-new-item {
    padding: 10px 14px;
    gap: 8px;
  }
  .whats-new-card .whats-new-item .item-title {
    font-size: 12px;
  }
  .whats-new-card .whats-new-item .item-meta {
    gap: 6px;
  }
  .whats-new-card .whats-new-item .item-type-label,
  .whats-new-card .whats-new-item .item-date,
  .whats-new-card .whats-new-item .item-validity {
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StudentDashboard/WhatsNew/WhatsNew.scss"],"names":[],"mappings":"AAAA;EACE;IAAK,6BAAA;EAEL;EADA;IAAO,4BAAA;EAIP;AACF;AAFA;EACE;IAAW,UAAA;EAKX;EAJA;IAAM,YAAA;EAON;AACF;AALA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAOF;AALE;EACE,SAAA;EACA,gBAAA;AAOJ;AAJE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;EACA,eAAA;AAMJ;AAJI;EACE,mBAAA;AAMN;AAHI;EACE,mBAAA;AAKN;AAFI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,qDAAA;AAIN;AADI;EACE,qBAAA;AAGN;AAAI;EACE,iCAAA;EACA,cAAA;AAEN;AACI;EACE,uFAAA;EACA,cAAA;EACA,8CAAA;AACN;AAEI;EACE,8CAAA;AAAN;AAGI;EACE,uFAAA;EACA,cAAA;EACA,8CAAA;AADN;AAII;EACE,8CAAA;AAFN;AAKI;EACE,SAAA;EACA,YAAA;AAHN;AAMI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJN;AAOI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AALN;AAQI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AANN;AAQM;EACE,kCAAA;EACA,cAAA;AANR;AASM;EACE,sFAAA;EACA,cAAA;EACA,0CAAA;AAPR;AAUM;EACE,uFAAA;EACA,cAAA;EACA,0CAAA;AARR;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAVN;AAaI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAXN;AAaM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AAXR;AAeI;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;AAbN;AAgBI;EACE,cAAA;AAdN;AAmBE;EACE,gCAAA;EACA,kCAAA;EACA,kCAAA;AAjBJ;AAmBI;EACE,mBAAA;AAjBN;AAoBI;EACE,0BAAA;AAlBN;AAsBI;EACE,0BAAA;AApBN;AAuBI;EACE,mBAAA;AArBN;AAyBE;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAvBJ;AAyBI;EACE,SAAA;AAvBN;AA0BI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AAxBN;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,iCAAA;AA1BJ;AA4BI;EACE,kCAAA;AA1BN;;AA+BA;EAEI;IACE,kBAAA;IACA,QAAA;EA7BJ;EA+BI;IACE,eAAA;EA7BN;EAgCI;IACE,QAAA;EA9BN;EAiCI;;;IAGE,eAAA;EA/BN;AACF","sourcesContent":["@keyframes shimmer {\n  0% { background-position: -100px 0; }\n  100% { background-position: 200px 0; }\n}\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.whats-new-card {\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  .whats-new-list {\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .whats-new-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 20px;\n    border-bottom: 1px solid #f0f0f0;\n    transition: all 0.2s ease;\n    cursor: pointer;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover {\n      background: #fafbfc;\n    }\n\n    .item-icon-wrap {\n      width: 32px;\n      height: 32px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n      transition: transform 0.2s ease, box-shadow 0.2s ease;\n    }\n\n    &:hover .item-icon-wrap {\n      transform: scale(1.1);\n    }\n\n    &.blog-item .item-icon-wrap {\n      background: rgba(68, 3, 191, 0.1);\n      color: #4403bf;\n    }\n\n    &.offer-item .item-icon-wrap {\n      background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(245, 158, 11, 0.05));\n      color: #f59e0b;\n      box-shadow: 0 0 0 1px rgba(245, 158, 11, 0.15);\n    }\n\n    &.offer-item:hover .item-icon-wrap {\n      box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);\n    }\n\n    &.news-item .item-icon-wrap {\n      background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(99, 102, 241, 0.05));\n      color: #3b82f6;\n      box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.15);\n    }\n\n    &.news-item:hover .item-icon-wrap {\n      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);\n    }\n\n    .item-content {\n      flex: 1;\n      min-width: 0;\n    }\n\n    .item-title {\n      font-size: 13px;\n      font-weight: 500;\n      color: #1d2026;\n      line-height: 1.3;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .item-meta {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-top: 3px;\n    }\n\n    .item-type-label {\n      font-size: 11px;\n      font-weight: 600;\n      padding: 1px 6px;\n      border-radius: 4px;\n      text-transform: uppercase;\n      letter-spacing: 0.3px;\n\n      &.blog-label {\n        background: rgba(68, 3, 191, 0.08);\n        color: #4403bf;\n      }\n\n      &.offer-label {\n        background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(251, 191, 36, 0.1));\n        color: #b45309;\n        border: 1px solid rgba(245, 158, 11, 0.15);\n      }\n\n      &.news-label {\n        background: linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(99, 102, 241, 0.08));\n        color: #1d4ed8;\n        border: 1px solid rgba(59, 130, 246, 0.15);\n      }\n    }\n\n    .item-date {\n      display: flex;\n      align-items: center;\n      gap: 3px;\n      font-size: 11px;\n      color: #9ca3af;\n    }\n\n    .item-validity {\n      font-size: 11px;\n      color: #b45309;\n      font-weight: 500;\n      display: flex;\n      align-items: center;\n      gap: 2px;\n\n      &::before {\n        content: '';\n        width: 5px;\n        height: 5px;\n        border-radius: 50%;\n        background: #f59e0b;\n        animation: pulse-dot 1.5s ease-in-out infinite;\n      }\n    }\n\n    .item-arrow {\n      background: none;\n      border: none;\n      padding: 0;\n      color: #c0c0c0;\n      cursor: pointer;\n      flex-shrink: 0;\n      transition: color 0.15s ease;\n    }\n\n    &:hover .item-arrow {\n      color: #4403bf;\n    }\n  }\n\n  // Offer/news items get a subtle left accent\n  .offer-item-wrap {\n    border-bottom: 1px solid #f0f0f0;\n    border-left: 3px solid transparent;\n    transition: border-color 0.2s ease;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover {\n      border-left-color: #f59e0b;\n    }\n\n    // News items get blue accent\n    &.news-item-wrap:hover {\n      border-left-color: #3b82f6;\n    }\n\n    .whats-new-item {\n      border-bottom: none;\n    }\n  }\n\n  .offer-expanded {\n    margin: 0 20px 12px;\n    padding: 10px 14px;\n    border-radius: 6px;\n    background: #fafbfc;\n    border-left: 3px solid #000;\n    font-size: 13px;\n    color: #1d2026;\n    line-height: 1.6;\n\n    p {\n      margin: 0;\n    }\n\n    .offer-expanded-title {\n      font-size: 11px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.3px;\n      margin-bottom: 4px;\n      opacity: 0.5;\n    }\n  }\n\n  .view-all-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    padding: 10px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #4403bf;\n    cursor: pointer;\n    border-top: 1px solid #f0f0f0;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: rgba(68, 3, 191, 0.04);\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .whats-new-card {\n    .whats-new-item {\n      padding: 10px 14px;\n      gap: 8px;\n\n      .item-title {\n        font-size: 12px;\n      }\n\n      .item-meta {\n        gap: 6px;\n      }\n\n      .item-type-label,\n      .item-date,\n      .item-validity {\n        font-size: 10px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
